import React, { useState } from "react";
import {
  betCheckObj,
  formatDate,
  toFixedWithoutRounding,
} from "../../Utils/Constant";

export default function ParlayModal({ isOpen, onClose, data }) {
  if (!isOpen) return null;
  console.log(data, "daat");
  return (
    <div
      id="createModal"
      className="pop_bg"
      style={{ height: "100%", width: "100%", display: "block" }}
      onClick={() => onClose()}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        _ngcontent-serverapp-c43
        className="pop_box pop_refer"
        style={{ height: "auto", overflow: "auto", width: "650px" }}
      >
        <a
          onClick={(e) => {
            e.preventDefault();
            onClose();
          }}
          _ngcontent-serverapp-c43
          href="#"
          className="close_pop ng-star-inserted"
        >
          close_pop
        </a>
        <h3 _ngcontent-serverapp-c84 style={{ display: "flex" }}>
          Parlay List Bets
          <span
            _ngcontent-serverapp-c84
            className="searchBet"
            style={{ "margin-left": "3rem" }}
          />
        </h3>
        <div
          _ngcontent-serverapp-c84
          className="modal-content"
          style={{ width: "fit-content" }}
        >
          <table _ngcontent-serverapp-c84 className="table-s">
            <tbody _ngcontent-serverapp-c84>
              <tr _ngcontent-serverapp-c84 className="align-L">
                <th _ngcontent-serverapp-c84>Sport</th>
                <th _ngcontent-serverapp-c84>Event</th>
                <th _ngcontent-serverapp-c84>Market</th>
                <th _ngcontent-serverapp-c84>selName</th>
                {/* <th _ngcontent-serverapp-c84>Bet taken</th> */}
                <th _ngcontent-serverapp-c84>Type</th>
                <th _ngcontent-serverapp-c84>Odds</th>
                <th _ngcontent-serverapp-c84>Result</th>
              </tr>
              {data?.map((item) => {
                return (
                  <tr
                    _ngcontent-serverapp-c84
                    className="align-L ng-star-inserted"
                  >
                    <td _ngcontent-serverapp-c84>
                      {betCheckObj[item?.eventType]}
                    </td>
                    <td _ngcontent-serverapp-c84>
                      {" "}
                      {betCheckObj[item?.eventType]}
                      <img
                        _ngcontent-serverapp-c84
                        src="/assets/images/transparent.gif"
                        className="fromto ng-star-inserted"
                      />
                      {item?.matchName}
                    </td>
                    <td _ngcontent-serverapp-c84>{item?.fancyName}</td>
                    <td _ngcontent-serverapp-c84>{item?.runnerName}</td>
                    {/* <td _ngcontent-serverapp-c84>
                      <span
                        _ngcontent-serverapp-c84
                        id="betPlaced"
                        className="small-date"
                      >
                        {formatDate(item.timeInserted)}
                      </span>
                    </td> */}
                    <td _ngcontent-serverapp-c84>
                      <span _ngcontent-serverapp-c84 className="back">
                        {" "}
                        Back{" "}
                      </span>
                    </td>
                    <td _ngcontent-serverapp-c84>
                      {toFixedWithoutRounding(item?.bhav)}
                    </td>
                    <td>
                      {item?.isDeclared ? (
                        <span
                          className={item?.result === "loss" ? "red" : "green"}
                        >
                          {item?.result === "loss"
                            ? `-${toFixedWithoutRounding(item?.loseAmount)}`
                            : toFixedWithoutRounding(item?.profitAmount)}
                        </span>
                      ) : (
                        <span>...</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
